<footer class="footer-area bg-fbf9f8">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <div class="logo">
                        <a routerLink="/"><img src="assets/img/logo.png" alt="image"></a>
                    </div>
                    <p>Open Software Information Technology (OSIT) puts together a bunch of passionate minds to transform your visions into reality imparting an awesome digital experience for your users. </p>
                    <ul class="social-links">
                        <li><a href="https://www.facebook.com/osit.com.sa/"><i class="icofont-facebook"></i></a></li>
                        <li><a href="https://twitter.com/osit_sa"><i class="icofont-twitter"></i></a></li>
                        <li><a href="https://www.instagram.com/osit_sa/"><i class="icofont-instagram"></i></a></li>
                        <li><a href="https://www.linkedin.com/company/osit-sa/"><i class="icofont-linkedin"></i></a></li>
                    </ul>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Our Solutions</h3>
                    <ul class="services-list">
                        <li><a routerLink="/odoo-solution">Odoo</a></li>
                        <li><a routerLink="/openbravo-solution">Openbravo</a></li>
                        <li><a routerLink="/hr-solution">HR Management System</a></li>
                        <li><a routerLink="/pos-solution">Point of Sale(POS)</a></li>
                        <li><a routerLink="/hospital-solution">Hospital Management System</a></li>
                        <li><a routerLink="/logistics-solution">Logistics Management System</a></li>
                    </ul>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Usefull links</h3>
                    <ul class="usefull-links">
                        <li><a routerLink="/about">About Us</a></li>
                        <li><a routerLink="/services">Our Services</a></li>
                        <li><a routerLink="/blogs">Blog</a></li>
                        <li><a href="https://support.osit.com.sa">Support</a></li>
                        <li><a routerLink="/quotation-request">Quotation Request</a></li>
                        <li><a routerLink="/career">Career</a></li>
                    </ul>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Contacts</h3>
                    <ul class="contact-list">
                        <li><span>Adress:</span> 7843 Eastern Ring Branch Road,<br>
                            Rayyan District Riyadh 14211-2294 <br>Saudi Arabia</li>
                        <li><span>Website:</span> <a routerLink="/">www.osit.com.sa</a></li>
                        <li><span>Email:</span> <a href="mailto:sales@osit.com.sa"> sales@osit.com.sa </a></li>
                        <li><span>Phone:</span> <a href="tel:920006748">920006748</a></li>
                        <li><span>Fax:</span> <a href="tel:+966114917224">(+966) 11 49 172 24</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    
    <div class="copyright-area">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <p>© Copyright 2022 Open Software Information Technology</p>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/terms-condition">Terms & Conditions</a></li>
                        <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>

<div class="go-top"><i class="icofont-stylish-up"></i></div>